import { httpClient } from '@/infrastructure/api/httpClient';
import { toCourseProgress } from '@/application/mapper/courseProgressMapper';
import type { CourseProgressResponse } from '@/application/dto/CourseProgressResponse';
import type { UpdateCourseProgressRequest } from '@/application/dto/UpdateCourseProgressRequest';
import type { CourseProgressRepository } from '@/domain/port/CourseProgressRepository';
import type { CourseProgress } from '@/domain/model/CourseProgress';

export class CourseProgressApiAdapter implements CourseProgressRepository {
  async getChapterProgress(chapterId: string): Promise<CourseProgress[]> {
    const { data } = await httpClient.get<CourseProgressResponse[]>(
      `/progress/chapters/${chapterId}/courses`,
    );
    return data.map(toCourseProgress);
  }

  async saveCourseProgress(courseId: string, progressPercentage: number): Promise<CourseProgress> {
    const request: UpdateCourseProgressRequest = { progressPercentage };
    const { data } = await httpClient.put<CourseProgressResponse>(
      `/progress/courses/${courseId}`,
      request,
    );
    return toCourseProgress(data);
  }
}
